import { z } from 'zod';

export const PlaceWhatsAppProviderSchema = z.enum(['META_OFFICIAL', 'WAHA_UNOFFICIAL']);
export type PlaceWhatsAppProvider = z.infer<typeof PlaceWhatsAppProviderSchema>;

export const PlaceWhatsAppAccountStatusSchema = z.enum([
  'PROVISIONING',
  'QR_PENDING',
  'CONNECTED',
  'DISCONNECTED',
  'BANNED',
]);
export type PlaceWhatsAppAccountStatus = z.infer<typeof PlaceWhatsAppAccountStatusSchema>;

export const RegisterPlaceWhatsAppAccountBodySchema = z
  .object({
    provider: PlaceWhatsAppProviderSchema,
    phoneE164: z.string().min(10).max(20),
    termsAccepted: z.boolean().optional(),
  })
  .superRefine((body, ctx) => {
    if (body.provider === 'WAHA_UNOFFICIAL' && body.termsAccepted !== true) {
      ctx.addIssue({
        code: 'custom',
        message: 'termsAccepted is required for WAHA_UNOFFICIAL',
        path: ['termsAccepted'],
      });
    }
  });
export type RegisterPlaceWhatsAppAccountBody = z.infer<
  typeof RegisterPlaceWhatsAppAccountBodySchema
>;

export const DisconnectPlaceWhatsAppAccountBodySchema = z.object({
  reason: z.string().max(500).optional(),
});
export type DisconnectPlaceWhatsAppAccountBody = z.infer<
  typeof DisconnectPlaceWhatsAppAccountBodySchema
>;

export const PlaceWhatsAppAccountResponseSchema = z.object({
  id: z.uuid(),
  placeId: z.uuid(),
  provider: PlaceWhatsAppProviderSchema,
  phoneE164: z.string(),
  status: PlaceWhatsAppAccountStatusSchema,
  termsAcceptedBy: z.uuid().nullable(),
  termsAcceptedAt: z.iso.datetime().nullable(),
  disconnectedReason: z.string().nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});
export type PlaceWhatsAppAccountResponse = z.infer<typeof PlaceWhatsAppAccountResponseSchema>;

export const PlaceWhatsAppPairingQrResponseSchema = z.object({
  mimeType: z.literal('image/png'),
  imageBase64: z.string().min(1),
});
export type PlaceWhatsAppPairingQrResponse = z.infer<typeof PlaceWhatsAppPairingQrResponseSchema>;
